import { EMPTY, of } from 'rxjs';

import { Msg, STORAGE_KEY } from '../user.actions';

export function hydrateEpic(_action$, _state$, { storage }) {
    const prev = storage.get(STORAGE_KEY);

    if (prev) {
        return of(Msg('User.Hydrate', prev));
    }

    return EMPTY;
}
